import { Cms as n } from "@sunrise/types";
import { defineComponent as T } from "vue";
import t from "./index141.js";
import a from "./index145.js";
import o from "./index174.js";
import s from "./index194.js";
import p from "./index195.js";
const I = T({
  name: "MsText",
  components: {
    MsBold: a,
    MsItalic: o,
    MsUnderline: p,
    MsTextLink: s,
    MsAnchor: t
  },
  props: {
    contentTag: Array,
    tagType: { default: "span", type: String },
    isIndex: { default: !1, type: Boolean }
  },
  setup(e) {
    function i(r) {
      switch (r) {
        case n.TagType.B:
          return a;
        case n.TagType.I:
          return o;
        case n.TagType.U:
          return p;
        case n.TagType.Br:
          return "br";
        case n.TagType.Link:
          return s;
        case n.TagType.Anchor:
          return t;
        default:
          return "span";
      }
    }
    function c(r) {
      switch (r.type) {
        case n.TagType.Link:
          return u(r);
        case n.TagType.Anchor:
          return f(r);
        default:
          return {};
      }
    }
    function u(r) {
      return {
        href: r.href,
        rel: r.rel,
        target: r.target,
        isCopyLink: !e.isIndex,
        isIndex: e.isIndex,
        isPRG: r.prgEnabled,
        sign: r.sign
      };
    }
    function f(r) {
      return {
        id: r.id
      };
    }
    return {
      getComponent: i,
      mapProps: c
    };
  }
});
export {
  I as default
};
